<template>
    <div>
        <div class="tab-card" v-if="show">

            <div :class="{'disabledInput': disabledAction || noClient}" class="card-body">
                <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                    <li :key="tab.name" class="nav-item" v-for="tab in tabs">
                        <a :class="{ 'btn-tab-selected': tabSelected == tab.component }"
                           @click="navigateTab(tab) "
                           class="btn px-4 float-right"
                           data-toggle="pill"
                        >{{ tab.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <TabDetail :DomainPack="DomainPack"
                   :codePromo="codePromo"
                   :emailError="errorEmail"
                   :formTab="form"
                   :role="role"
                   :showCountry="showCountry"
                   :showDomain="showDomain"
                   :tabName="tabName"
                   :tabSelected="tabSelected"
                   @disabledButton="getDisabledButton"
                   @formValidate="getValidate"
                   @goToFunctionality="goToFunctionalityLocal"
                   @nextTab="getTab"
                   @noClient="getNoClient"
                   @phoneClick="getPhoneClick"
        />

    </div>
</template>

<script>
    import TabDetail from './TabDetail';
    import {verifEmail} from '../shared/services/user.service';

    export default {
        name: 'Tab',
        components: {
            TabDetail
        },
        props: {
            role: String,
            tabs: Array,
            currentTabComponent: String,
            show: Boolean,
            codePromo: Boolean,
            form: Object,
            currentTab: Object,
            showDomain: Boolean,
            showCountry: Boolean,
            DomainPack: Object
        },
        data() {
            return {
                tabSelected: null,
                tabKey: null,
                validateFormAction: null,
                phoneValidate: null,
                disabledAction: false,
                noClient: false,
                errorEmail: null,
                goToFunctionalityAction: true,
                tabName: null
            };
        },
        created() {
            this.tabSelected = this.currentTabComponent;
        },
        methods: {
            getTab(selected) {
                this.tabSelected = selected.component;
            },
            getValidate(v) {
                this.validateFormAction = v;
            },
            getPhoneClick(phoneValidate) {
                this.phoneValidate = phoneValidate;
            },
            navigateTab(tab) {
                this.tabName = tab.name;
                if (this.tabSelected == 'OrganisationInfo' && (this.$route.path.includes('organisation/add') ||
                    this.$route.path.includes('client/add')) && tab.component == 'ClientInfo') {
                    this.tabSelected = tab.component;
                    this.errorEmail = null;
                }
                if (!this.goToFunctionalityAction) {
                    return;
                }
                if (this.validateFormAction) {
                    this.validateFormAction.$touch();
                    if (this.validateFormAction.$invalid || (this.phoneValidate != null && !this.phoneValidate)) {
                        return;
                    } else {
                        if (this.tabSelected == 'ClientInfo' && this.$route.path.includes('client/add')) {
                            verifEmail(this.form.organisation.client.email).then(
                                response => {
                                    if (response) {
                                        console.log(response);
                                        this.tabSelected = tab.component;
                                        this.errorEmail = null;
                                    }
                                }, error => {
                                    this.errorEmail = error.response.data.error;
                                    return;
                                });
                        } else {
                            this.tabSelected = tab.component;
                            this.errorEmail = null;
                        }
                    }
                } else {
                    this.tabSelected = tab.component;
                }

            },
            getDisabledButton(disabled) {
                this.disabledAction = disabled;
            },
            getNoClient(noClient) {
                this.noClient = noClient;
            },
            goToFunctionalityLocal(val) {
                this.goToFunctionalityAction = val;
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/share/tab.css';
</style>
